module.exports = __webpack_public_path__ + "img/badge-check.d2c2d820.svg";